import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/declinedFilled.svg';

export const IconDeclinedFilled = createIconComponent(Icon);
